import { StorageInfoResponse } from '../api/fetchStorageInfo';
import { fileSignatureIcon } from '../components/common/Icons';
import StorageInfo from '../components/common/StorageInfo';
import { useSelector } from 'react-redux';
import { getIsDicomEnabled } from '../store/selectors/session';
import { getAclViewClassName } from '../restrictions/utils';
import { SREV2 } from '../api/pushGenie';

export const MY_RECORDS = 'my-records';
export const REQUEST = 'request';
export const DICOM = 'dicom';
export type ACTIVE_TAB = typeof MY_RECORDS | typeof REQUEST | typeof DICOM;

const fileSignature = fileSignatureIcon('fill-darwin-neutral-900');

const SwitchPanel: React.FC<{
    activeTab: string;
    setActiveTab: (activeTab: ACTIVE_TAB) => void;
    storageInfo?: StorageInfoResponse;
}> = ({ activeTab, setActiveTab, storageInfo }) => {
    const isDicomEnabled = useSelector(getIsDicomEnabled);

    return (
        <div
            className={`flex bg-white items-center justify-between font-600 text-14 leading-28 cursor-pointer px-16`}
        >
            <div className="flex items-center">
                <div
                    className={`flex space-x-12 px-8 items-center border-b-2 py-6  ${
                        activeTab === MY_RECORDS
                            ? 'border-b-2 border-accent-neutral-900'
                            : 'border-transparent'
                    }  text-13 font-700`}
                    onClick={() => setActiveTab(MY_RECORDS)}
                >
                    {fileSignature}
                    <p
                        className={`${
                            activeTab === MY_RECORDS ? 'text-accent-neutral-900' : 'text-neutral-3'
                        } text-13 font-700`}
                    >
                        My Records
                    </p>
                </div>
                <div
                    className={`flex space-x-12 px-8 items-center border-b-2 ml-32 py-6   ${
                        activeTab === REQUEST
                            ? 'border-b-2 border-accent-neutral-900'
                            : 'border-transparent'
                    } text-13 font-700 ${getAclViewClassName(SREV2.ABHA)}`}
                    onClick={() => setActiveTab(REQUEST)}
                >
                    {fileSignature}
                    <p
                        className={`${
                            activeTab === REQUEST ? 'text-accent-neutral-900' : 'text-neutral-3'
                        } text-13 font-700`}
                    >
                        ABHA Request
                    </p>
                </div>
                {isDicomEnabled && (
                    <div
                        className={`flex space-x-12 px-8 items-center border-b-2 ml-32 py-3 ${
                            activeTab === DICOM
                                ? 'border-b-2 border-accent-neutral-900'
                                : 'border-transparent'
                        } text-13 font-700`}
                        onClick={() => setActiveTab(DICOM)}
                    >
                        <img src="/images/dicom-file.png" className="w-20 h-24" />
                        <p
                            className={`${
                                activeTab === DICOM ? 'text-accent-neutral-900' : 'text-neutral-3'
                            } text-13 font-700`}
                        >
                            DICOM
                        </p>
                    </div>
                )}
            </div>
            {storageInfo && (
                <StorageInfo storage={storageInfo.storage} className="flex items-center gap-4" />
            )}
        </div>
    );
};

export default SwitchPanel;
